import { getLogger } from "@goodgamestudios/logger";
const logger = getLogger("AssetsPool");
class AssetsPool {
    private pool = new Map<string, Array<any>>();


    private allocate<T>(constructorFunc: AConstructor<T>): void {
        const name = (constructorFunc as any).__fname || constructorFunc.name;
        const instance = new constructorFunc();
        if (!this.pool.has(name)) {
            this.pool.set(name, []);
        }
        this.pool.get(name).push(instance);
    }

    public recycle(instance: any): void {
        const name = instance.constructor.__fname || instance.constructor.name;
        if (!this.pool.has(name)) {
            logger.warn("trying to recycle an item that was not in the pool ", name);
            return;
        }
        this.pool.get(name).push(instance);
    }

    public obtain<T>(constructorFunc: AConstructor<T>): T {
        let obj: any;
        const name = (constructorFunc as any).__fname || constructorFunc.name;
        if (!this.hasAvailable(name)) {
            this.allocate(constructorFunc);
        }
        obj = this.pool.get(name).shift();
        return obj;
    }

    private hasAvailable(assetsName: string): boolean {
        return this.pool.has(assetsName) && this.pool.get(assetsName).length > 0;
    }

    public clearPool() {
        this.pool.clear();
    }

    public getNestedSize(): number {
        const size = Array.from(this.pool.values()).reduce((s, current) => {
            s += current.length;
            return s;
        }, 0);
        logger.debug(`Pool has currently ${this.pool.size} Classes with a total of ${size} instances`);
        return size;
    }
}


type AConstructor<T> = (new (...args: any[]) => T);

export const assetsPool = new AssetsPool();

